import { RestTurnStepScheduleModel } from '@main-application/boards/interfaces/board';
import { RestInspectionsModel } from '@main-application/inspections/models/rest-inspections-model.interface';
import { RestArchivedTurnover, RestTurnoverDataModel } from '@shared/interfaces/turnover.interface';

import { TimezoneEntityHelperCommon } from './timezone-entity-common.helper';
import { TimezoneHelper } from './timezone.helper';

export class TimezoneEntityHelper extends TimezoneEntityHelperCommon {
  public static readonly fixTimezoneForRestInspectionsModelToClient = (
    data: RestInspectionsModel,
    timezone: number
  ) => {
    return super.fixTimezoneForModelToClient(data, timezone, ['dueDate']);
  };
  public static readonly fixTimezoneForRestInspectionsModelToServer = (
    data: RestInspectionsModel,
    timezone: number
  ) => {
    return super.fixTimezoneForModelToServer(data, timezone, ['dueDate']);
  };
  public static readonly fixTimezoneForTurnStepScheduleModelToClient = (
    data: RestTurnStepScheduleModel,
    timezone: number
  ) => {
    return super.fixTimezoneForModelToClient(data, timezone, [
      'dueDate',
      'originalDueDate',
      'turnoverDateAvailable',
      'dateCompleted',
    ]);
  };
  public static readonly fixTimezoneForTurnStepScheduleModelToServer = (
    data: RestTurnStepScheduleModel,
    timezone: number
  ) => {
    return super.fixTimezoneForModelToServer(data, timezone, [
      'dueDate',
      'originalDueDate',
      'turnoverDateAvailable',
      'dateCompleted',
    ]);
  };
  public static readonly fixTimezoneForArchivedTurnoverDataModelToClient = (
    //Has no idea what this function for, maybe should be deleted?
    data: RestArchivedTurnover,
    timezone: number
  ) => {
    return this.fixTimezoneForArchivedTurnoverDataModel(
      data,
      timezone,
      TimezoneHelper.addTimeZoneAndKeepOnlyDatePart,
      TimezoneHelper.replaceTimezoneToClient,
      this.fixTimezoneForModelToClient
    );
  };
  public static readonly fixTimezoneForTurnoverDataModelToClient = (data: RestTurnoverDataModel, timezone: number) => {
    return super.fixTimezoneForModelToClient(
      data,
      timezone,
      ['dateMoveIn', 'dateMoveOut', 'pmsMoveOutDate', 'lastRentDate', 'dateAvailable', 'leaseExecutionDate'],
      [
        {
          field: 'turnStepSchedules',
          f: (list: RestTurnStepScheduleModel[], tz) => {
            list.forEach(e => this.fixTimezoneForTurnStepScheduleModelToClient(e, tz));
            return list;
          },
        },
      ]
    );
  };
  public static readonly fixTimezoneForTurnoverDataModelToServer = (data: RestTurnoverDataModel, timezone: number) => {
    return super.fixTimezoneForModelToServer(
      data,
      timezone,
      ['dateMoveIn', 'dateMoveOut', 'pmsMoveOutDate', 'lastRentDate', 'dateAvailable', 'leaseExecutionDate'],
      [
        {
          field: 'turnStepSchedules',
          f: (list: RestTurnStepScheduleModel[], tz) => {
            list.forEach(e => this.fixTimezoneForTurnStepScheduleModelToClient(e, tz));
            return list;
          },
        },
      ]
    );
  };

  public static readonly fixTimezoneForArchivedTurnoverDataModel = (
    data: RestArchivedTurnover,
    timezone: number,
    fVanila: (date: Date | string) => Date,
    fFullDate: (date: Date | string, timezone: number) => Date,
    fModel: <T>(data: T, timezone: number) => T
  ) => {
    if (!data) return data;
    //Vanile Date
    data.turnoverStartDate = fFullDate(data.turnoverStartDate, timezone);
    data.turnoverEndDate = fFullDate(data.turnoverEndDate, timezone);
    return data;
  };
}
